import MenuColaboradores from '../../../Analytics/Components/Menu/MenuColaboradores'
import { useCallback, useEffect, useRef, useState } from 'react'
import ReqPotentialFiles from '../../../../API/Services/PotentialFiles/PotentialFiles'

import { MdDelete, MdFolder, MdVisibility } from 'react-icons/md'
import Loading from '../../../../Components/Loading/Loading'
import { Spinner } from 'react-bootstrap'
import { historicEvaluationsTranslate } from '../../../../i18n/translatedMessages'
import { getEmployeesURL } from '../../../../API/Employee/Employee'

const PotentialFiles = () => {
	const token = localStorage.getItem('token')
	const [employees, setEmployees] = useState([])
	const [employeeSelected, setEmployeeSelected] = useState(null)
	const [loading, setLoading] = useState(false)
	const [files, setFiles] = useState([])
	const [downloading, setIsDownloading] = useState(null)
	const [loadingDelete, setIsLoadingDelete] = useState(false)
	const companyId = JSON.parse(localStorage.getItem('user')).id
	const fileInputRef = useRef(null)

	const fetchData = useCallback(async () => {
		setLoading(true)
		try {
			const company = JSON.parse(localStorage.getItem('user')).id
			const response = await ReqPotentialFiles.getEmployeeList(companyId)

			const employeeImgs = await getEmployeesURL(company, token)

			const updatedEvaluations = response.map(item => ({
				...item,
				profileImg: employeeImgs.find(img => img.mydnaUserEmail === item.email)?.url || null,
			}))

			setEmployees(updatedEvaluations)
		} finally {
			setLoading(false)
		}
	}, [companyId])

	useEffect(() => {
		fetchData()
	}, [fetchData])

	const handleEmployee = id => {
		const selectedEmployee = employees.find(emp => emp.id === id)
		console.log('Selected employee:', selectedEmployee)
		setEmployeeSelected(selectedEmployee)
		setFiles(selectedEmployee.assets)
	}

	const handleFileUpload = async event => {
		const file = event.target.files[0]
		if (!file) return

		setLoading(true)
		try {
			const respRoute = await ReqPotentialFiles.getUploadRoute(employeeSelected.id, companyId, file.name)

			await ReqPotentialFiles.sendFile(file, respRoute)

			await fetchData()

			setEmployees(prevEmployees => {
				const updatedEmployee = prevEmployees.find(emp => emp.id === employeeSelected.id)
				if (updatedEmployee) {
					setEmployeeSelected(updatedEmployee)
					setFiles(updatedEmployee.assets)
				}
				return prevEmployees
			})

			console.log('Arquivo enviado com sucesso!')
		} catch (error) {
			console.error('Erro ao enviar o arquivo:', error)
		} finally {
			setLoading(false)

			if (fileInputRef.current) {
				fileInputRef.current.value = ''
			}
		}
	}

	const handleFileDelete = async (fileId, name) => {
		setLoading(true)
		try {
			await ReqPotentialFiles.deleteFile(fileId)

			fetchData()

			setFiles(prevFiles => prevFiles.filter(file => file.id !== fileId))
			setEmployees(prevEmployees =>
				prevEmployees.map(emp => {
					if (emp.id === employeeSelected.id) {
						return {
							...emp,
							assets: emp.assets.filter(asset => asset.id !== fileId),
						}
					}
					return emp
				})
			)
		} catch (error) {
			console.error('Error deleting file:', error)
		} finally {
			setLoading(false)
		}
	}

	const handleFileDownload = async fileKey => {
		setIsDownloading(fileKey)
		try {
			const downloadUrl = await ReqPotentialFiles.downloadFile(fileKey)
			window.open(downloadUrl, '_blank')
		} catch (error) {
			console.error('Error downloading file:', error)
		} finally {
			setIsDownloading(null)
		}
	}

	return loading ? (
		<Loading />
	) : (
		<>
			<div className='tw-max-w-3xl tw-mr-5 '>
				<h3 className='tw-font-bold  tw-mb-4'>{historicEvaluationsTranslate.historicEvaluations}</h3>
			</div>
			<div className='tw-flex tw-h-full tw-pr-5'>
				<div className='tw-w-1/3 border-r border-gray-200 tw-p-4 tw-flex tw-flex-col' style={{ overflow: 'hidden' }}>
					<MenuColaboradores
						logo={false}
						analytics={false}
						handleEmployee={handleEmployee}
						employeeList={employees}
						employeeId={employeeSelected?.id}
						overflow={false}
					/>
				</div>

				<div className='tw-w-2/3 tw-bg-white tw-shadow-lg tw-rounded-2xl tw-p-6 tw-flex tw-flex-col' style={{ border: '1px solid #7A6BE8' }}>
					<div className='tw-flex tw-items-center tw-justify-between tw-bg-purple-50 tw-p-4 tw-rounded-xl'>
						<div className='tw-flex tw-items-center tw-gap-4'>
							<img
								src={employeeSelected?.profileImg ?? 'https://assets.mydna.company/profile-placeholder.png'}
								alt={employeeSelected?.name}
								className='tw-w-10 tw-h-10 2xl:tw-w-14 2xl:tw-h-14 tw-rounded-full'
							/>
							<div className='tw-text-sm 2xl:tw-flex 2xl:tw-items-center 2xl:tw-gap-5 2xl:tw-text-base'>
								<div className='tw-font-bold'>{employeeSelected?.name || 'Seleccione un colaborador'}</div>
								<div className='tw-text-gray-500'>{employeeSelected?.employeeLevel?.level}</div>
								<div className='tw-flex tw-items-center tw-gap-2 tw-text-gray-500'>
									<MdFolder />
									<span>{files.length} arquivos</span>
								</div>
							</div>
						</div>
						{employeeSelected && (
							<label className='tw-bg-purple-500 tw-text-white tw-px-4 tw-py-2 tw-rounded-lg tw-cursor-pointer hover:tw-bg-purple-700 tw-text-sm 2xl:tw-text-base'>
								+ Agregar evaluación
								<input type='file' ref={fileInputRef} className='tw-hidden' onChange={handleFileUpload} />
							</label>
						)}
					</div>

					<div className='tw-mt-4 tw-space-y-3 tw-overflow-y-auto tw-flex-1 tw-pr-2'>
						{loadingDelete ? (
							<Loading />
						) : files.length === 0 && !!employeeSelected ? (
							<div className='tw-flex tw-items-center tw-justify-between tw-bg-gray-50 tw-p-6 tw-rounded-xl tw-border'>
								<div>
									<div className='tw-font-bold'>Aún no se han cargado evaluaciones.</div>
									<div>
										Registra tu primera evaluación{' '}
										<span className='tw-text-purple-500 tw-cursor-pointer' onClick={() => fileInputRef.current.click()}>
											haciendo clic aquí.
										</span>
									</div>
								</div>
							</div>
						) : (
							files.map((file, idx) => (
								<div key={file.id || idx} className='tw-flex tw-items-center tw-justify-between tw-p-4 tw-bg-white border tw-rounded-xl'>
									<div className='tw-flex tw-items-center tw-gap-4'>
										<div className='tw-bg-gray-50 tw-p-3 tw-rounded-xl'>
											<MdFolder size={24} className='tw-text-gray-400' />
										</div>
										<div>
											<div>{file.original_name}</div>
										</div>
									</div>
									<div className='tw-flex tw-items-center tw-gap-3'>
										<div
											className='tw-p-2 tw-border tw-rounded-lg hover:tw-bg-purple-50 tw-cursor-pointer'
											onClick={() => handleFileDownload(file.key)}
										>
											{downloading === file.key ? (
												<Spinner animation='border' variant='primary' className='tw-w-5 tw-h-5' />
											) : (
												<MdVisibility className='tw-text-purple-500 2xl:tw-h-5 2xl:tw-w-5' />
											)}
										</div>
										<div
											className='tw-p-2 tw-border tw-rounded-lg tw-bg-purple-50 hover:tw-bg-purple-100 tw-cursor-pointer'
											onClick={() => handleFileDelete(file.id, file.original_name)}
										>
											<MdDelete className='tw-text-purple-500 2xl:tw-h-5 2xl:tw-w-5' />
										</div>
									</div>
								</div>
							))
						)}
					</div>
				</div>
			</div>
		</>
	)
}
export default PotentialFiles
